(function ($) {
  'use strict';

  var breakpoint = 990;
  var peekVisible = 44;
  var slideGap = 12;

  function refreshCarousel($track) {
    if ($track.hasClass('owl-loaded')) {
      $track.trigger('refresh.owl.carousel');
    }
  }

  function initFeaturedImagesCarousel() {
    $('[data-sm-featured-images]').each(function () {
      var $track = $(this);
      var $items = $track.children('.sm-featured-images__item');

      if ($items.length === 0) {
        return;
      }

      var initialized = $track.hasClass('owl-loaded');
      var isMobile = $(window).width() < breakpoint;

      if (isMobile && !initialized) {
        $track.addClass('owl-carousel owl-theme').owlCarousel({
          items: 1,
          loop: $items.length > 1,
          dots: true,
          nav: false,
          margin: slideGap,
          stagePadding: peekVisible,
          autoplay: false,
          touchDrag: true,
          mouseDrag: true,
          onInitialized: function () {
            refreshCarousel($track);
          },
          onResized: function () {
            refreshCarousel($track);
          }
        });

        $track.find('img').off('load.smFeaturedImages').on('load.smFeaturedImages', function () {
          refreshCarousel($track);
        });
      } else if (isMobile && initialized) {
        refreshCarousel($track);
      } else if (!isMobile && initialized) {
        $track.trigger('destroy.owl.carousel');
        $track.removeClass('owl-carousel owl-loaded owl-drag owl-grab owl-theme');
      }
    });
  }

  var resizeTimer;

  $(document).ready(initFeaturedImagesCarousel);
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initFeaturedImagesCarousel, 150);
  });
  document.addEventListener('shopify:section:load', initFeaturedImagesCarousel);
})(jQuery);